<template>

  <div>
    <ContentsHeader>
      <template v-slot:title01>{{jobName}}</template>
      <template v-slot:explain01>
自動車メーカーが開発、生産する新車、中古車を仕入れ、お客様に対して販売・メンテナンス（車両点検など）をおこなうのが自動車ディーラーの営業職です。車の購入を検討されているお客様の要望にヒアリングしたうえで最もふさわしい車や装備を提案します。新車・中古車の販促業務だけではなく、自動車保険の募集、JAFの加入、試乗車のご案内、車両買取・下取り対応など幅広い業務をおこないます。購買単価が高い商品の接客が求められるこの業界の営業職にはどんな特徴がみられるのでしょうか。      </template>
      <template v-slot:yarigai01><span class="ddin">働いた分だけ給料が上がり、セールスの順位が明確にでる</span><span class="ddin">(埼玉県 30歳 男性)</span></template>
      <template v-slot:yarigai02><span class="ddin">普段出会えない社会的地位の高い方と対等に話が出来る</span><span class="ddin">(東京都 39歳 男性)</span></template>
      <template v-slot:yarigai03><span class="ddin">人生の中で数えるくらいの大きな買い物に携わること</span><span class="ddin">(福岡県 37歳 男性)</span></template>
      <template v-slot:img-headbg><img src="../assets/img/cardealer/headbg.svg" :alt="jobName" class="img -cardealer"></template>
      <template v-slot:img-headp><img src="../assets/img/cardealer/person.svg" :alt="jobName" class="imgp -cardealer"></template>
    </ContentsHeader>

    <div class="contents-block">

      <section class="job-section">
        <div class="jsinner">
          <div class="block-two -aistretch -jcsb -bptablet">
            <div class="block -b48p -p0">
              <BalanceChartSection :explain="bcExplain" :radarData="radarData"></BalanceChartSection>
            </div>
            <div class="block -b48p -p0">
              <JobChangeRateSection
                :explain="jcExplain"
                :doughnutData="doughnutData"
                :doughnutDataFake="doughnutDataFake"
              ></JobChangeRateSection>
            </div><!-- .block -->
          </div><!-- .block-two -->
        </div><!-- .jsinner -->
      </section>

      <PersonalCharaSection :sevenData="sevenData" :secTtl="'自動車ディーラー業界'" >
        <template v-slot:feature>型にはまらない<br>心配性な専門家</template>
        <template v-slot:imgpup><img src="../assets/img/cardealer/person.svg" alt="自動車ディーラーの営業" class="imgcvperson -foodcampany"></template>
      </PersonalCharaSection>
    
      <div class="lb-area">
        <div class="lbinner block-two -bptablet">
          <div class="block">
            <CareerTypeSection :graphData="graphData" :explain="ctExplain" :jobName="'自動車ディーラー'"></CareerTypeSection>
          </div><!-- .block -->
          <div class=" block">
            <SalesTypeSection :graph2Data="graph2Data" :explain="stExplain" :jobName="'自動車ディーラー'"></SalesTypeSection>
          </div><!-- .block -->
        </div><!-- .block-two -->
      </div><!-- .lb-area -->

      <ResultSection :job="'cardealer'">
        <template v-slot:jobname>自動車ディーラーの営業</template>
        <template v-slot:title01>型にはまらない柔軟性</template>
        <template v-slot:explain01>
      自由な気性で、経験則や感覚で物事を判断する傾向があります。<br>
マニュアル通りに進めることよりも、洞察力を働かせて臨機応変に動くことに長けているといえるでしょう。顧客の要望や生活様式に寄り添った柔軟な提案を行う上で、重要な能力であると考えられます。
        </template>
        <template v-slot:title02>思いやりのあるスペシャリスト</template>
        <template v-slot:explain02>
      専門知識を身に着けたいという気持ちが強く、献身性も高い傾向にあります。<br>
商材が顧客の生活に密接に関係していること<br>
人生でも大きな買い物に立ち会うこと<br>
から、自分の知識や経験が顧客の生活を大きく変える、という責任感やプライドが表れていると言えます。
        </template>
        <template v-slot:imgperson><img src="../assets/img/cardealer/person.svg" alt="自動車ディーラーの営業" class="rsimg"></template>
      </ResultSection>

      <section class="other-section">
        <h2 class="osttl">その他の業界ごとの詳細をのぞく</h2>
        <div class="osinner">
          <DetailsList></DetailsList>
        </div><!-- .osinner -->
      </section>

    </div><!-- contents-block -->
  </div>

</template>


<script>

import ContentsHeader from "../components/ContentsHeader.vue";
import ResultSection from "../components/ResultSection.vue";
import DetailsList from "../components/DetailsList.vue";

import BalanceChartSection from "../components/BalanceChartSection.vue";
import JobChangeRateSection from "../components/JobChangeRateSection.vue";
import PersonalCharaSection from "../components/PersonalCharaSection.vue";
import CareerTypeSection from "../components/CareerTypeSection.vue";
import SalesTypeSection from "../components/SalesTypeSection.vue";

export default {
  data() {
    return {
      pageTitle: "自動車ディーラーの営業をのぞく",
      pageURL: "cardealer",
      pageDescription: "SALES SALES SCOPEでは不動産、保険、ITなど人気10業界の営業職に人物特性と成績に関する調査を実施。自動車メーカーが開発、生産する新車、中古車を仕入れ、お客様に対して販売・メンテナンス（車両点検など）をおこなうのが自動車ディーラーの営業職です。購買単価が高い商品の接客が求められるこの業界の営業職にはどんな特徴がみられるのでしょうか。",

      jobName: "自動車ディーラーの営業",
      bcExplain: "献身的だが精神力と計画性が低い",
      jcExplain: "転職回数はやや少なめ",
      pcExplain: "型にはまらない心配性な専門家",
      ctExplain: "個人として技能を磨く職人タイプがやや多い\n公私両立を図るワークライフバランスタイプはやや少ない",
      stExplain: "顧客と親密な関係を築こうとし、提案をどのように伝えるか重視するタイプが多い",
      radarData: [2.31, 5.82, 8.79, 2.98, 6.37],
      doughnutData: [50, 5, 26, 2, 17],
      doughnutDataFake: [50, 5, 24, 4, 17],
      sevenData: [4, 7, 1, 5, 1, 4, 7],
      graphData: [
        { num: 1, val: 18 },
        { num: 2, val: 18 },
        { num: 3, val: 9 },
        { num: 4, val: 14 },
        { num: 5, val: 5 },
        { num: 6, val: 9 },
        { num: 7, val: 18 },
        { num: 8, val: 9 },
      ],
      graph2Data: [
        { num: 1, val: 4.54545454545455 },
        { num: 2, val: 27.2727272727273 },
        { num: 3, val: 22.7272727272727 },
        { num: 4, val: 27.2727272727273 },
        { num: 5, val: 18.1818181818182 },
      ],
    };
  },
  components: {
    BalanceChartSection,
    JobChangeRateSection,
    PersonalCharaSection,
    CareerTypeSection,
    SalesTypeSection,
    ContentsHeader,
    ResultSection,
    DetailsList    
  },
  metaInfo: {
    title: "自動車ディーラーの営業をのぞく | 営業職の特徴を人物特性からのぞいてみた",
    titleTemplate: "%s | SALES SCOPE",
    htmlAttrs: {
      lang: "jp",
    },
  },
  mounted: function(){
    // document.title = title;
    document.querySelector("meta[name='description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:title']").setAttribute('content', this.pageTitle + " | 営業職の特徴を人物特性からのぞいてみた | SALES SCOPE");
    document.querySelector("meta[property='og:description']").setAttribute('content', this.pageDescription);
    document.querySelector("meta[property='og:url']").setAttribute('content', 'https://sales-score.jp/scope/' + this.pageURL);
  }

};
</script>